const MobileCloseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M13.2001 12.0001L22.3501 2.8501C22.6876 2.5126 22.6876 1.9876 22.3501 1.6501C22.0126 1.3126 21.4876 1.3126 21.1501 1.6501L12.0001 10.8001L2.8501 1.6501C2.5126 1.3126 1.9876 1.3126 1.6501 1.6501C1.3126 1.9876 1.3126 2.5126 1.6501 2.8501L10.8001 12.0001L1.6501 21.1501C1.3126 21.4876 1.3126 22.0126 1.6501 22.3501C1.8001 22.5001 2.0251 22.6126 2.2501 22.6126C2.4751 22.6126 2.7001 22.5376 2.8501 22.3501L12.0001 13.2001L21.1501 22.3501C21.3001 22.5001 21.5251 22.6126 21.7501 22.6126C21.9751 22.6126 22.2001 22.5376 22.3501 22.3501C22.6876 22.0126 22.6876 21.4876 22.3501 21.1501L13.2001 12.0001Z'
        fill='#9CA3AF'
      />
    </svg>
  );
};

export default MobileCloseIcon;
